import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-root" className="min-h-screen grid place-items-center p-6" style={{ background: "hsl(var(--navy))" }}>
      <div className="w-full max-w-md rounded-3xl bg-card p-8 text-center shadow-2xl">
        <div className="w-16 h-16 rounded-full grid place-items-center mx-auto bg-slate-100">
          <XCircle className="w-9 h-9 text-slate-500" />
        </div>
        <div className="mt-5 font-heading text-2xl" style={{ color: "hsl(var(--navy))" }}>Payment cancelled</div>
        <p className="text-sm text-muted-foreground mt-2">No charge was made. You can pick a plan whenever you&apos;re ready.</p>
        <Link to="/pricing" data-testid="cancel-back-to-pricing" className="mt-6 inline-flex rounded-full px-5 py-2.5 text-sm font-semibold text-white" style={{ background: "hsl(var(--navy))" }}>Back to pricing</Link>
      </div>
    </div>
  );
}
